import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import './dealer-five-star-awards.scss';

export function DealerFiveStarAwards(props) {
  const { years, className, whiteLogo } = props;
  if (!years.length) return null;

  const logoUrl = getStaticImageUrl(`/img/dealer-thanks/5star-dealer-side${whiteLogo ? '-white' : ''}.png`);

  return (
    <div className={classNames('five-stars-award', className)}>
      <div className="five-stars-award-logo mb-md-0_5">
        <img src={logoUrl} alt="5 star award" />
      </div>
      <div className={classNames('five-stars-award-years', { 'five-stars-award-years-gray': !whiteLogo })}>
        Awarded {years.join(', ')}
      </div>
    </div>
  );
}

DealerFiveStarAwards.propTypes = {
  years: PropTypes.arrayOf(PropTypes.number).isRequired,
  className: PropTypes.string,
  whiteLogo: PropTypes.bool,
};
DealerFiveStarAwards.defaultProps = {
  className: '',
  whiteLogo: false,
};
